module.exports = __webpack_public_path__ + "img/pizza_dough_plain.c9587213.jpg";